export default __webpack_public_path__ + "static/media/grafema_SET_04.9b936d56.jpg";